module.exports = __webpack_public_path__ + "static/woman-forgot-square.f11e5365.jpg";